import {
  SEQUENCE_ACTION_TYPE_EMAIL,
  SEQUENCE_ACTION_TYPE_LINKEDIN_CONNECTION_REQUEST,
  SEQUENCE_ACTION_TYPE_LINKEDIN_MESSAGE,
  SEQUENCE_ACTION_TYPE_AGENT_CONVERSATION,
  SEQUENCE_ACTION_TYPE_VOICE_MESSAGE,
  INBOX_TYPE_GMAIL,
  INBOX_TYPE_DOMAIN,
  INBOX_MESSAGE_TYPE_RECEIVED,
  INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
  INBOX_MESSAGE_TYPE_SENT_SEQUENCE,
} from "../constants";

// Demo sequence data for the sequences table
export const DEMO_SEQUENCES = [
  {
    id: "demo-seq-1",
    name: "Enterprise SaaS Outreach",
    active: true,
    memberCount: 2847,
    stepCount: 5,
    executedStepCount: 11234,
    completedMemberCount: 1892,
    inProgressMemberCount: 743,
    notStartedMemberCount: 156,
    bouncedMemberCount: 42,
    unsubscribedMemberCount: 14,
    prospectValue: 15000,
    totalReplies: 312,
    totalBookings: 47,
    created_date: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000).toISOString(),
    updated_date: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-seq-2",
    name: "Series A Founders Campaign",
    active: true,
    memberCount: 1456,
    stepCount: 4,
    executedStepCount: 4892,
    completedMemberCount: 987,
    inProgressMemberCount: 389,
    notStartedMemberCount: 63,
    bouncedMemberCount: 12,
    unsubscribedMemberCount: 5,
    prospectValue: 25000,
    totalReplies: 189,
    totalBookings: 34,
    created_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString(),
    updated_date: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-seq-3",
    name: "Mid-Market Tech Directors",
    active: true,
    memberCount: 3421,
    stepCount: 6,
    executedStepCount: 16842,
    completedMemberCount: 2156,
    inProgressMemberCount: 1087,
    notStartedMemberCount: 134,
    bouncedMemberCount: 31,
    unsubscribedMemberCount: 13,
    prospectValue: 8500,
    totalReplies: 423,
    totalBookings: 62,
    created_date: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
    updated_date: new Date(Date.now() - 1 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-seq-4",
    name: "Q1 Product Launch - VP Engineering",
    active: false,
    memberCount: 892,
    stepCount: 5,
    executedStepCount: 4460,
    completedMemberCount: 892,
    inProgressMemberCount: 0,
    notStartedMemberCount: 0,
    bouncedMemberCount: 18,
    unsubscribedMemberCount: 7,
    prospectValue: 12000,
    totalReplies: 156,
    totalBookings: 28,
    created_date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
    updated_date: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-seq-5",
    name: "Healthcare IT Decision Makers",
    active: true,
    memberCount: 1678,
    stepCount: 4,
    executedStepCount: 5234,
    completedMemberCount: 1023,
    inProgressMemberCount: 567,
    notStartedMemberCount: 78,
    bouncedMemberCount: 8,
    unsubscribedMemberCount: 2,
    prospectValue: 18000,
    totalReplies: 234,
    totalBookings: 41,
    created_date: new Date(Date.now() - 21 * 24 * 60 * 60 * 1000).toISOString(),
    updated_date: new Date(Date.now() - 30 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-seq-6",
    name: "FinTech CFO Outreach",
    active: true,
    memberCount: 2134,
    stepCount: 5,
    executedStepCount: 8756,
    completedMemberCount: 1456,
    inProgressMemberCount: 589,
    notStartedMemberCount: 67,
    bouncedMemberCount: 15,
    unsubscribedMemberCount: 7,
    prospectValue: 22000,
    totalReplies: 287,
    totalBookings: 52,
    created_date: new Date(Date.now() - 35 * 24 * 60 * 60 * 1000).toISOString(),
    updated_date: new Date(Date.now() - 45 * 60 * 1000).toISOString(),
  },
];

// Demo overall metrics for the sequences page header cards
export const DEMO_SEQUENCE_METRICS = {
  totals: {
    total_executions: 51418,
    total_unique_opens: 32847,
    total_unique_clicks: 8234,
    total_unique_replies: 1601,
    total_bookings: 264,
    total_bounces: 126,
    total_ooo: 187,
    total_pending_approvals: 23,
    pipeline_value: 4752000,
    overall_open_rate: 63.88,
    overall_click_rate: 16.01,
    overall_reply_rate: 3.11,
    overall_booking_rate: 0.51,
    overall_bounce_rate: 0.25,
    overall_ooo_rate: 0.36,
  },
};

// Demo step-by-step metrics for individual sequence metrics dialog
export const DEMO_SEQUENCE_STEP_METRICS = {
  sequence_name: "Enterprise SaaS Outreach",
  total_members: 2847,
  totals: {
    total_executions: 11234,
    total_unique_opens: 7156,
    total_unique_clicks: 1823,
    total_unique_replies: 312,
    total_bookings: 47,
    total_bounces: 42,
    total_ooo: 58,
    total_pending_approvals: 8,
    pipeline_value: 5385000,
    overall_open_rate: 63.7,
    overall_click_rate: 16.23,
    overall_reply_rate: 2.78,
    overall_booking_rate: 0.42,
    overall_bounce_rate: 0.37,
    overall_ooo_rate: 0.52,
  },
  stepMetrics: [
    {
      stepId: "step-1",
      stepOrder: 1,
      stepName: "Initial Introduction",
      step_action_type: SEQUENCE_ACTION_TYPE_EMAIL,
      totalExecutions: 2847,
      unique_opens: 1934,
      unique_clicks: 523,
      unique_replies: 89,
      unique_bookings: 12,
      open_rate: 67.93,
      click_rate: 18.37,
      reply_rate: 3.13,
      booking_rate: 0.42,
      failedCount: 42,
    },
    {
      stepId: "step-2",
      stepOrder: 2,
      stepName: "Value Proposition Follow-up",
      step_action_type: SEQUENCE_ACTION_TYPE_EMAIL,
      totalExecutions: 2456,
      unique_opens: 1623,
      unique_clicks: 434,
      unique_replies: 76,
      unique_bookings: 11,
      open_rate: 66.08,
      click_rate: 17.67,
      reply_rate: 3.09,
      booking_rate: 0.45,
      failedCount: 0,
    },
    {
      stepId: "step-3",
      stepOrder: 3,
      stepName: "AI Agent Outreach",
      step_action_type: SEQUENCE_ACTION_TYPE_AGENT_CONVERSATION,
      totalExecutions: 2134,
      unique_opens: 0,
      unique_clicks: 0,
      unique_replies: 156,
      unique_bookings: 18,
      open_rate: 0,
      click_rate: 0,
      reply_rate: 7.31,
      booking_rate: 0.84,
      failedCount: 23,
      successRate: 98.92,
    },
    {
      stepId: "step-4",
      stepOrder: 4,
      stepName: "Personalized Voice Message",
      step_action_type: SEQUENCE_ACTION_TYPE_VOICE_MESSAGE,
      totalExecutions: 1876,
      unique_opens: 0,
      unique_clicks: 0,
      unique_replies: 67,
      unique_bookings: 9,
      open_rate: 0,
      click_rate: 0,
      reply_rate: 3.57,
      booking_rate: 0.48,
      failedCount: 34,
      successRate: 98.19,
    },
    {
      stepId: "step-5",
      stepOrder: 5,
      stepName: "Final Follow-up Email",
      step_action_type: SEQUENCE_ACTION_TYPE_EMAIL,
      totalExecutions: 1921,
      unique_opens: 1599,
      unique_clicks: 866,
      unique_replies: 80,
      unique_bookings: 15,
      open_rate: 83.24,
      click_rate: 45.08,
      reply_rate: 4.16,
      booking_rate: 0.78,
      failedCount: 0,
    },
  ],
};

// Generate demo activity timeline hourly data
// This function creates realistic hourly data for the last 3 days with 3 distinct humps
export const generateDemoActivityTimelineData = () => {
  const now = new Date();
  const hourlyData: { hour: string; count: number; actionType: string }[] = [];
  const timelineEvents: {
    opens: { hour: string; count: number }[];
    clicks: { hour: string; count: number }[];
    bounces: { hour: string; count: number }[];
    scheduleViews: { hour: string; count: number }[];
    bookings: { hour: string; count: number }[];
    replies: { hour: string; count: number }[];
  } = {
    opens: [],
    clicks: [],
    bounces: [],
    scheduleViews: [],
    bookings: [],
    replies: [],
  };

  // Generate data for the last 72 hours
  for (let i = 72; i >= 0; i--) {
    const hour = new Date(now.getTime() - i * 60 * 60 * 1000);
    hour.setMinutes(0, 0, 0);
    const hourStr = hour.toISOString();

    const hourOfDay = hour.getHours();

    // Create 3 distinct humps using a bell curve pattern centered around 11am-2pm
    // Peak hours: 10am-3pm with maximum at noon
    let multiplier = 0;

    if (hourOfDay >= 8 && hourOfDay <= 18) {
      // Create a smooth bell curve peaking at noon (hour 12)
      const distanceFromPeak = Math.abs(hourOfDay - 12);
      // Bell curve formula: e^(-(x^2)/(2*sigma^2))
      // Using sigma = 3 for a nice spread
      multiplier = Math.exp(-(distanceFromPeak * distanceFromPeak) / (2 * 3 * 3));
      // Scale up and add some randomness
      multiplier = multiplier * (4 + Math.random() * 1.5);
    } else {
      // Very low activity outside business hours
      multiplier = 0.1 + Math.random() * 0.15;
    }

    // Emails sent - primary activity
    const emailCount = Math.floor((20 + Math.random() * 15) * multiplier);
    if (emailCount > 0) {
      hourlyData.push({
        hour: hourStr,
        count: emailCount,
        actionType: SEQUENCE_ACTION_TYPE_EMAIL,
      });
    }

    // Agent conversations (fewer than emails, but significant)
    const agentCount = Math.floor((8 + Math.random() * 6) * multiplier);
    if (agentCount > 0) {
      hourlyData.push({
        hour: hourStr,
        count: agentCount,
        actionType: SEQUENCE_ACTION_TYPE_AGENT_CONVERSATION,
      });
    }

    // Voice messages (fewer than agent conversations)
    const voiceCount = Math.floor((4 + Math.random() * 4) * multiplier);
    if (voiceCount > 0) {
      hourlyData.push({
        hour: hourStr,
        count: voiceCount,
        actionType: SEQUENCE_ACTION_TYPE_VOICE_MESSAGE,
      });
    }

    // Opens (about 60-70% of emails)
    const opens = Math.floor(emailCount * (0.6 + Math.random() * 0.1));
    if (opens > 0) {
      timelineEvents.opens.push({ hour: hourStr, count: opens });
    }

    // Clicks (about 15-20% of emails)
    const clicks = Math.floor(emailCount * (0.15 + Math.random() * 0.05));
    if (clicks > 0) {
      timelineEvents.clicks.push({ hour: hourStr, count: clicks });
    }

    // Replies (about 2-4% of emails)
    const replies = Math.floor(emailCount * (0.02 + Math.random() * 0.02));
    if (replies > 0) {
      timelineEvents.replies.push({ hour: hourStr, count: replies });
    }

    // Bookings (about 0.5-1% of emails)
    const bookings = Math.floor(emailCount * (0.005 + Math.random() * 0.005));
    if (bookings > 0) {
      timelineEvents.bookings.push({ hour: hourStr, count: bookings });
    }

    // Schedule views (about 3-5% of emails)
    const scheduleViews = Math.floor(emailCount * (0.03 + Math.random() * 0.02));
    if (scheduleViews > 0) {
      timelineEvents.scheduleViews.push({ hour: hourStr, count: scheduleViews });
    }

    // Bounces (very low, about 0.2-0.5% of emails)
    const bounces = Math.floor(emailCount * (0.002 + Math.random() * 0.003));
    if (bounces > 0) {
      timelineEvents.bounces.push({ hour: hourStr, count: bounces });
    }
  }

  return {
    hourlyData,
    timelineEvents,
  };
};

// Demo inbox data
export const DEMO_INBOXES = [
  {
    id: "demo-inbox-1",
    name: "Sarah Mitchell",
    email: "sarah@acmesales.com",
    domain: "acmesales.com",
    inboxType: INBOX_TYPE_DOMAIN,
    type: INBOX_TYPE_DOMAIN,
    sharing: "Private",
    status: "active",
    syncEnabled: true,
    warmupEnabled: true,
    warmupScore: 94,
    dailySendLimit: 150,
    sentToday: 87,
    messageCount: 1247,
    unreadCount: 23,
    created_date: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-inbox-2",
    name: "James Rodriguez",
    email: "james@acmesales.com",
    domain: "acmesales.com",
    inboxType: INBOX_TYPE_DOMAIN,
    type: INBOX_TYPE_DOMAIN,
    sharing: "Private",
    status: "active",
    syncEnabled: true,
    warmupEnabled: true,
    warmupScore: 91,
    dailySendLimit: 150,
    sentToday: 112,
    messageCount: 2341,
    unreadCount: 45,
    created_date: new Date(Date.now() - 85 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-inbox-3",
    name: "Emily Chen",
    email: "emily@acmesales.com",
    domain: "acmesales.com",
    inboxType: INBOX_TYPE_DOMAIN,
    type: INBOX_TYPE_DOMAIN,
    sharing: "Shared",
    status: "active",
    syncEnabled: true,
    warmupEnabled: true,
    warmupScore: 97,
    dailySendLimit: 150,
    sentToday: 65,
    messageCount: 1876,
    unreadCount: 12,
    created_date: new Date(Date.now() - 75 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-inbox-4",
    name: "Michael Thompson",
    email: "michael@outreach.io",
    domain: "outreach.io",
    inboxType: INBOX_TYPE_DOMAIN,
    type: INBOX_TYPE_DOMAIN,
    sharing: "Private",
    status: "active",
    syncEnabled: true,
    warmupEnabled: true,
    warmupScore: 89,
    dailySendLimit: 200,
    sentToday: 143,
    messageCount: 3456,
    unreadCount: 67,
    created_date: new Date(Date.now() - 120 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-inbox-5",
    name: "Jessica Williams",
    email: "jessica@outreach.io",
    domain: "outreach.io",
    inboxType: INBOX_TYPE_DOMAIN,
    type: INBOX_TYPE_DOMAIN,
    sharing: "Shared",
    status: "active",
    syncEnabled: true,
    warmupEnabled: false,
    warmupScore: 82,
    dailySendLimit: 200,
    sentToday: 178,
    messageCount: 2987,
    unreadCount: 34,
    created_date: new Date(Date.now() - 100 * 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-inbox-6",
    name: "David Park",
    email: "david.park@gmail.com",
    domain: "david.park@gmail.com",
    inboxType: INBOX_TYPE_GMAIL,
    type: INBOX_TYPE_GMAIL,
    sharing: "Private",
    status: "active",
    syncEnabled: true,
    warmupEnabled: false,
    warmupScore: 78,
    dailySendLimit: 100,
    sentToday: 45,
    messageCount: 892,
    unreadCount: 8,
    created_date: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000).toISOString(),
  },
];

// Demo inbox messages
export const DEMO_INBOX_MESSAGES = [
  {
    id: "demo-msg-1",
    inboxId: "demo-inbox-1",
    inbox: { name: "Sarah Mitchell", domain: "acmesales.com" },
    sender: "john.smith@techcorp.com",
    senderName: "John Smith",
    recipient: "sarah@acmesales.com",
    subject: "Re: Partnership Opportunity - Interested in Learning More",
    bodyPreview: "Hi Sarah, Thank you for reaching out. I've reviewed your proposal and I'm very interested in scheduling a call to discuss further. Would next Tuesday at 2pm work for you?",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "interested",
      sentiment: "positive",
      intent: "Schedule meeting",
      keywords: ["interested", "scheduling", "call"],
      confidence: 94,
      needsHumanReview: false,
    },
    replied: false,
    generatedReply: null,
    isRead: false,
    created_date: new Date(Date.now() - 15 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-2",
    inboxId: "demo-inbox-2",
    inbox: { name: "James Rodriguez", domain: "acmesales.com" },
    sender: "amanda.lee@startupxyz.io",
    senderName: "Amanda Lee",
    recipient: "james@acmesales.com",
    subject: "Re: Quick Question About Your Platform",
    bodyPreview: "James, this looks exactly like what we've been searching for! Can you send over some case studies from companies in our industry? We're in the fintech space.",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "interested",
      sentiment: "positive",
      intent: "Request information",
      keywords: ["case studies", "fintech", "searching for"],
      confidence: 91,
      needsHumanReview: false,
    },
    replied: false,
    generatedReply: "Hi Amanda, Thank you for your interest! I'd be happy to share our fintech case studies...",
    isRead: false,
    created_date: new Date(Date.now() - 32 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-3",
    inboxId: "demo-inbox-3",
    inbox: { name: "Emily Chen", domain: "acmesales.com" },
    sender: "robert.johnson@enterprise.net",
    senderName: "Robert Johnson",
    recipient: "emily@acmesales.com",
    subject: "Re: Exclusive Offer for Enterprise Clients",
    bodyPreview: "Emily, I appreciate you thinking of us. Unfortunately, we just signed a 3-year contract with a competitor last month. Feel free to reach out again when that expires.",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "not_interested",
      sentiment: "neutral",
      intent: "Decline - existing contract",
      keywords: ["contract", "competitor", "reach out again"],
      confidence: 97,
      needsHumanReview: false,
    },
    replied: true,
    generatedReply: null,
    isRead: true,
    created_date: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-4",
    inboxId: "demo-inbox-1",
    inbox: { name: "Sarah Mitchell", domain: "acmesales.com" },
    sender: "lisa.wang@innovateco.com",
    senderName: "Lisa Wang",
    recipient: "sarah@acmesales.com",
    subject: "Meeting Request: Demo of Your Solution",
    bodyPreview: "Hi Sarah, Our VP of Sales would like to see a demo of your platform. Are you available this Thursday or Friday afternoon? We have budget allocated for Q2.",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "meeting_request",
      sentiment: "positive",
      intent: "Schedule demo",
      keywords: ["demo", "VP of Sales", "budget allocated"],
      confidence: 98,
      needsHumanReview: false,
    },
    replied: false,
    generatedReply: null,
    isRead: false,
    created_date: new Date(Date.now() - 45 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-5",
    inboxId: "demo-inbox-4",
    inbox: { name: "Michael Thompson", domain: "outreach.io" },
    sender: "chris.martinez@globaltech.com",
    senderName: "Chris Martinez",
    recipient: "michael@outreach.io",
    subject: "Re: Streamline Your Sales Process",
    bodyPreview: "Michael, I'm currently out of the office until March 15th with limited access to email. I'll respond to your message when I return. For urgent matters, please contact...",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "out_of_office",
      sentiment: "neutral",
      intent: "Auto-reply",
      keywords: ["out of the office", "limited access"],
      confidence: 99,
      needsHumanReview: false,
    },
    replied: false,
    generatedReply: null,
    isRead: true,
    created_date: new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-6",
    inboxId: "demo-inbox-2",
    inbox: { name: "James Rodriguez", domain: "acmesales.com" },
    sender: "patricia.brown@mediumbiz.co",
    senderName: "Patricia Brown",
    recipient: "james@acmesales.com",
    subject: "Re: Introducing Our New Features",
    bodyPreview: "Hi James, Quick question - does your platform integrate with Salesforce? We're heavily invested in their ecosystem and any new tool needs to work seamlessly with it.",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "question",
      sentiment: "neutral",
      intent: "Integration inquiry",
      keywords: ["integrate", "Salesforce", "ecosystem"],
      confidence: 88,
      needsHumanReview: true,
    },
    replied: false,
    generatedReply: null,
    isRead: false,
    created_date: new Date(Date.now() - 1.5 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-7",
    inboxId: "demo-inbox-5",
    inbox: { name: "Jessica Williams", domain: "outreach.io" },
    sender: "kevin.nguyen@fastgrowth.io",
    senderName: "Kevin Nguyen",
    recipient: "jessica@outreach.io",
    subject: "Re: Scale Your Outreach Efforts",
    bodyPreview: "Jessica, we've been using a similar tool but are looking for alternatives. Would you be able to provide a comparison of your features vs. Apollo.io? Pricing would also be helpful.",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "interested",
      sentiment: "positive",
      intent: "Comparison request",
      keywords: ["alternatives", "comparison", "pricing"],
      confidence: 92,
      needsHumanReview: false,
    },
    replied: false,
    generatedReply: null,
    isRead: false,
    created_date: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-8",
    inboxId: "demo-inbox-3",
    inbox: { name: "Emily Chen", domain: "acmesales.com" },
    sender: "emily@acmesales.com",
    senderName: "Emily Chen",
    recipient: "mark.davis@targetcompany.com",
    subject: "Following Up on Our Conversation",
    bodyPreview: "Hi Mark, I wanted to follow up on our call last week. I've attached the ROI calculator we discussed. Let me know if you have any questions or would like to schedule a follow-up.",
    messageType: INBOX_MESSAGE_TYPE_SENT_SEQUENCE,
    replyClassification: null,
    replied: false,
    generatedReply: null,
    isRead: true,
    created_date: new Date(Date.now() - 5 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-9",
    inboxId: "demo-inbox-1",
    inbox: { name: "Sarah Mitchell", domain: "acmesales.com" },
    sender: "daniel.kim@bigcorp.com",
    senderName: "Daniel Kim",
    recipient: "sarah@acmesales.com",
    subject: "Referral: You Should Talk to Our Head of Sales",
    bodyPreview: "Sarah, I'm not the right person for this, but I think you should connect with our Head of Sales, Jennifer Adams. I've CC'd her on this email. She's always looking for tools to help the team.",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED_REPLY,
    replyClassification: {
      category: "referral",
      sentiment: "positive",
      intent: "Internal referral",
      keywords: ["connect", "Head of Sales", "CC'd"],
      confidence: 95,
      needsHumanReview: false,
    },
    replied: false,
    generatedReply: null,
    isRead: false,
    created_date: new Date(Date.now() - 6 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: "demo-msg-10",
    inboxId: "demo-inbox-4",
    inbox: { name: "Michael Thompson", domain: "outreach.io" },
    sender: "nancy.taylor@newprospect.com",
    senderName: "Nancy Taylor",
    recipient: "michael@outreach.io",
    subject: "Saw Your Product on LinkedIn",
    bodyPreview: "Hi Michael, I came across your company's post on LinkedIn about AI-powered outreach. We're a growing team of 50 SDRs and struggling with personalization at scale. Can we chat?",
    messageType: INBOX_MESSAGE_TYPE_RECEIVED,
    replyClassification: {
      category: "interested",
      sentiment: "positive",
      intent: "Inbound inquiry",
      keywords: ["LinkedIn", "SDRs", "personalization"],
      confidence: 96,
      needsHumanReview: false,
    },
    replied: false,
    generatedReply: null,
    isRead: false,
    created_date: new Date(Date.now() - 25 * 60 * 1000).toISOString(),
  },
];

// Demo content metrics for the content engine metrics bar
export const DEMO_CONTENT_METRICS = {
  views: 184230,
  reach: 142580,
  likes: 8943,
  comments: 1276,
  shares: 2184,
  engagement: 12403,
  trackedPosts: 12,
};

// Demo content timeseries data for the content engine chart (last 7 days)
export const generateDemoContentTimeseries = () => {
  const now = new Date();
  const dates: string[] = [];
  for (let i = 6; i >= 0; i--) {
    const d = new Date(now);
    d.setDate(d.getDate() - i);
    dates.push(d.toISOString().slice(0, 10));
  }

  const posts = [
    {
      contentId: "demo-content-1",
      title: "How AI Agents Are Transforming B2B Sales in 2026",
      publishedUrl: "https://example.com/ai-agents-b2b-sales",
      platform: "linkedin",
      label: "How AI Agents Are Transforming B2B Sales",
      baseViews: [380, 4210, 3870, 1240, 2680, 2410, 1980],
    },
    {
      contentId: "demo-content-2",
      title: "The Complete Guide to Cold Email Personalization",
      publishedUrl: "https://example.com/cold-email-guide",
      platform: "linkedin",
      label: "The Complete Guide to Cold Email Personalization",
      baseViews: [1820, 1640, 2970, 910, 1380, 2240, 1120],
    },
    {
      contentId: "demo-content-3",
      title: "5 Signals Your ICP Actually Cares About",
      publishedUrl: "https://example.com/icp-signals",
      platform: "linkedin",
      label: "5 Signals Your ICP Actually Cares About",
      baseViews: [740, 520, 1310, 1680, 590, 1420, 830],
    },
    {
      contentId: "demo-content-4",
      title: "Why Most Sequences Fail at Step 3",
      publishedUrl: "https://example.com/sequences-step-3",
      platform: "twitter",
      label: "Why Most Sequences Fail at Step 3",
      baseViews: [110, 890, 240, 1180, 670, 340, 920],
    },
  ];

  return {
    dates,
    series: posts.map((p) => ({
      contentId: p.contentId,
      title: p.title,
      publishedUrl: p.publishedUrl,
      platform: p.platform,
      label: p.label,
      data: p.baseViews,
    })),
  };
};

// Demo inbox metrics for the inbox metrics bar
export const DEMO_INBOX_METRICS = {
  totalInboxes: 4,
  totalMessages: 18240,
  recentMessages: 1284,
  uniqueSenders: 612,
  messagesToday: 47,
  activeThreads: 238,
};

// Demo inbox timeseries data for the inbox chart (last 7 days, hourly buckets)
export const generateDemoInboxTimeseries = (
  groupBy: "inbox" | "type" = "inbox"
) => {
  const now = new Date();
  const currentHour = new Date(now);
  currentHour.setMinutes(0, 0, 0);
  const totalHours = 7 * 24;
  const dates: string[] = [];
  for (let i = totalHours - 1; i >= 0; i--) {
    const d = new Date(currentHour);
    d.setHours(d.getHours() - i);
    dates.push(d.toISOString().replace(/\.\d{3}Z$/, "Z"));
  }

  const buildHourly = (dailyTotals: number[]): number[] => {
    const hourly: number[] = [];
    for (let day = 0; day < dailyTotals.length; day++) {
      const total = dailyTotals[day];
      for (let hour = 0; hour < 24; hour++) {
        const businessHourWeight =
          hour >= 9 && hour <= 17 ? 1.5 : hour >= 6 && hour <= 22 ? 0.6 : 0.1;
        const base = (total / 24) * businessHourWeight;
        const jitter = 0.7 + ((day * 24 + hour) % 7) * 0.09;
        hourly.push(Math.max(0, Math.round(base * jitter)));
      }
    }
    return hourly;
  };

  if (groupBy === "type") {
    const types = [
      { id: "received", name: "Received", daily: [61, 74, 82, 49, 93, 88, 67] },
      { id: "sent_sequence", name: "Sent (sequence)", daily: [112, 138, 127, 84, 151, 142, 119] },
      { id: "sent_reply", name: "Sent (reply)", daily: [23, 31, 28, 19, 34, 30, 24] },
      { id: "sent_compose", name: "Sent (compose)", daily: [14, 11, 18, 9, 16, 13, 10] },
    ];
    return {
      dates,
      series: types.map((t) => ({
        id: t.id,
        name: t.name,
        label: t.name,
        data: buildHourly(t.daily),
      })),
    };
  }

  const inboxes = [
    {
      inboxId: "demo-inbox-1",
      name: "sales@parallellabs.app",
      daily: [42, 58, 61, 37, 74, 69, 52],
    },
    {
      inboxId: "demo-inbox-2",
      name: "support@parallellabs.app",
      daily: [18, 22, 31, 14, 27, 33, 19],
    },
    {
      inboxId: "demo-inbox-3",
      name: "founders@parallellabs.app",
      daily: [9, 14, 7, 12, 21, 16, 11],
    },
    {
      inboxId: "demo-inbox-4",
      name: "partnerships@parallellabs.app",
      daily: [5, 3, 8, 11, 6, 9, 4],
    },
  ];

  return {
    dates,
    series: inboxes.map((i) => ({
      inboxId: i.inboxId,
      name: i.name,
      label: i.name,
      data: buildHourly(i.daily),
    })),
  };
};

export const DEMO_LIST_METRICS = {
  total_lists: 23,
  total_rows: 48210,
  active_automations: 11,
  recent_rows: 3240,
  rows_today: 186,
  recent_actions: 7820,
};

export const generateDemoListsTimeseries = () => {
  const now = new Date();
  const currentHour = new Date(now);
  currentHour.setMinutes(0, 0, 0);
  const totalHours = 7 * 24;
  const dates: string[] = [];
  for (let i = totalHours - 1; i >= 0; i--) {
    const d = new Date(currentHour);
    d.setHours(d.getHours() - i);
    dates.push(d.toISOString().replace(/\.\d{3}Z$/, "Z"));
  }

  const buildHourly = (dailyTotals: number[]): number[] => {
    const hourly: number[] = [];
    for (let day = 0; day < dailyTotals.length; day++) {
      const total = dailyTotals[day];
      for (let hour = 0; hour < 24; hour++) {
        const businessHourWeight =
          hour >= 9 && hour <= 17 ? 1.5 : hour >= 6 && hour <= 22 ? 0.6 : 0.1;
        const base = (total / 24) * businessHourWeight;
        const jitter = 0.7 + ((day * 24 + hour) % 7) * 0.09;
        hourly.push(Math.max(0, Math.round(base * jitter)));
      }
    }
    return hourly;
  };

  const series = [
    {
      id: "new_rows",
      name: "New Rows",
      label: "New Rows",
      data: buildHourly([420, 512, 486, 301, 598, 552, 371]),
    },
    {
      id: "updated_rows",
      name: "Updated Rows",
      label: "Updated Rows",
      data: buildHourly([180, 244, 201, 132, 268, 240, 166]),
    },
    {
      id: "actions",
      name: "Actions",
      label: "Actions",
      data: buildHourly([980, 1184, 1051, 642, 1342, 1226, 895]),
    },
  ];

  return { dates, series };
};

// Demo data for the Analytics page stat-card grids.
// Shapes match what the backend /<feature>/statistics endpoints return
// (snake_case in many cases), since Analytics.tsx renders these directly.

export const DEMO_HOURS_SAVED = {
  totalHours: 1284,
  valueSaved: 64200,
  breakdown: {
    email_sent: { label: "Emails sent", count: 18420 },
    linkedin_message: { label: "LinkedIn messages", count: 3240 },
    linkedin_connection: { label: "LinkedIn connections", count: 1680 },
    agent_conversation: { label: "Agent conversations", count: 486 },
    voice_message: { label: "Voice messages", count: 312 },
    content_generated: { label: "Content generated", count: 94 },
  },
};

export const DEMO_LIST_STATS = {
  total_lists: 23,
  total_rows: 48210,
  active_automations: 11,
  total_executions: 7820,
  success_rate: 96.4,
};

export const DEMO_INBOX_STATS = {
  total_inboxes: 6,
  recent_messages: 1284,
  unique_senders: 612,
  messages_today: 47,
};

export const DEMO_AGENT_STATS = {
  total_agents: 12,
  recent_conversations: 486,
  recent_messages: 9820,
  conversations_today: 54,
};

export const DEMO_CONTENT_STATS = {
  total_content: 142,
  published_content: 118,
  publishing_rate: 83.1,
  recent_content: 34,
  total_images: 267,
};

export const DEMO_MARKETING_CAMPAIGN_METRICS = {
  totalCampaigns: 18,
  activeCampaigns: 4,
  totalSent: 24156,
  totalOpened: 8234,
  totalClicked: 1847,
  openRate: 0.3411,
  clickRate: 0.0765,
};

export const generateDemoMarketingCampaignTimeseries = () => {
  const now = new Date();
  const currentHour = new Date(now);
  currentHour.setMinutes(0, 0, 0);
  const totalHours = 7 * 24;
  const dates: string[] = [];
  for (let i = totalHours - 1; i >= 0; i--) {
    const d = new Date(currentHour);
    d.setHours(d.getHours() - i);
    dates.push(d.toISOString().replace(/\.\d{3}Z$/, "Z"));
  }

  const buildHourly = (dailyTotals: number[]): number[] => {
    const hourly: number[] = [];
    for (let day = 0; day < dailyTotals.length; day++) {
      const total = dailyTotals[day];
      for (let hour = 0; hour < 24; hour++) {
        const businessHourWeight =
          hour >= 9 && hour <= 17 ? 1.8 : hour >= 6 && hour <= 22 ? 0.4 : 0.05;
        const base = (total / 24) * businessHourWeight;
        const jitter = 0.7 + ((day * 24 + hour) % 7) * 0.09;
        hourly.push(Math.max(0, Math.round(base * jitter)));
      }
    }
    return hourly;
  };

  const series = [
    {
      id: "sent",
      name: "Sent",
      label: "Sent",
      data: buildHourly([3120, 4210, 3870, 2480, 4560, 3980, 1936]),
    },
    {
      id: "opens",
      name: "Opens",
      label: "Opens",
      data: buildHourly([1062, 1434, 1320, 844, 1556, 1356, 662]),
    },
    {
      id: "clicks",
      name: "Clicks",
      label: "Clicks",
      data: buildHourly([238, 322, 296, 190, 349, 304, 148]),
    },
  ];

  return { dates, series };
};

export const DEMO_AGENT_METRICS = {
  total_agents: 12,
  active_agents: 9,
  total_conversations: 4320,
  recent_conversations: 486,
  conversations_today: 54,
  recent_messages: 9820,
};

export const generateDemoAgentsTimeseries = () => {
  const now = new Date();
  const currentHour = new Date(now);
  currentHour.setMinutes(0, 0, 0);
  const totalHours = 7 * 24;
  const dates: string[] = [];
  for (let i = totalHours - 1; i >= 0; i--) {
    const d = new Date(currentHour);
    d.setHours(d.getHours() - i);
    dates.push(d.toISOString().replace(/\.\d{3}Z$/, "Z"));
  }

  const buildHourly = (dailyTotals: number[]): number[] => {
    const hourly: number[] = [];
    for (let day = 0; day < dailyTotals.length; day++) {
      const total = dailyTotals[day];
      for (let hour = 0; hour < 24; hour++) {
        const businessHourWeight =
          hour >= 9 && hour <= 17 ? 1.5 : hour >= 6 && hour <= 22 ? 0.6 : 0.1;
        const base = (total / 24) * businessHourWeight;
        const jitter = 0.7 + ((day * 24 + hour) % 7) * 0.09;
        hourly.push(Math.max(0, Math.round(base * jitter)));
      }
    }
    return hourly;
  };

  const series = [
    {
      id: "conversations",
      name: "Conversations",
      label: "Conversations",
      data: buildHourly([62, 74, 68, 41, 86, 78, 54]),
    },
    {
      id: "agent_messages",
      name: "Agent Messages",
      label: "Agent Messages",
      data: buildHourly([720, 842, 756, 486, 961, 888, 612]),
    },
    {
      id: "user_messages",
      name: "User Messages",
      label: "User Messages",
      data: buildHourly([640, 748, 672, 432, 854, 790, 544]),
    },
  ];

  return { dates, series };
};
